import React from 'react';
import styled from 'styled-components';

const DisclaimerContainer = styled.section`
  background: ${props => props.theme.colors.primaryDark};
  color: white;
  padding: 3rem 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.05) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.03) 0%, transparent 50%);
    pointer-events: none;
  }
`;

const DisclaimerContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;
  z-index: 1;
`;

const DisclaimerTitle = styled.h2`
  color: white;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
`;

const DisclaimerText = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  line-height: 1.7;
  margin-bottom: 1.5rem;
  text-align: justify;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    font-size: 0.95rem;
    text-align: left;
    padding: 0 0.5rem;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const DisclaimerSection = () => {
  return (
    <DisclaimerContainer>
      <DisclaimerContent>
        <DisclaimerTitle>Disclaimer</DisclaimerTitle>
        
        <DisclaimerText>
          RPL Support is an educational facilitator committed to providing guidance and information to students aiming to further their academic and professional pursuits. It is important to understand that RPL Support is not a Registered Training Organisation (RTO) and therefore does not issue nationally recognised qualifications or certificates.
        </DisclaimerText>
        
        <DisclaimerText>
          In situations where RPL Support refers a student to an RTO for consideration of a specific program, the issuing of any nationally recognised certificate upon successful completion of that program is the sole responsibility of the RTO. RPL Support bears no responsibility for any decisions students make regarding their education pathways and is not liable for any consequences arising from those choices.
        </DisclaimerText>
        
        <DisclaimerText>
          Students seeking advice on course outcomes, professional licensing, visa requirements, or related matters are strongly encouraged to consult qualified, registered professionals. For licensing-related inquiries, RPL Support recommends contacting the appropriate regulatory or licensing authority to confirm and validate any relevant information.
        </DisclaimerText>
        
        <DisclaimerText>
          By using RPL Support's services, you acknowledge and accept that RPL Support will not be held liable for any loss or damages resulting from your decisions concerning educational or career objectives.
        </DisclaimerText>
      </DisclaimerContent>
    </DisclaimerContainer>
  );
};

export default DisclaimerSection;
